import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type compareItem = {
  title: string;
};

interface stateType {
  comparedList: compareItem[] | null;
  selectedColumn: number;
}

const initialState = {
  comparedList: null,
  selectedColumn: 0,
} satisfies stateType as stateType;

const slice = createSlice({
  name: "compare",
  initialState,
  reducers: {
    setComparedList: (state, action: PayloadAction<compareItem>) => {
      const existing = Array.isArray(state.comparedList)
        ? state.comparedList
        : [];

      if (action?.payload) {
        if (!existing?.find((item) => item?.title === action?.payload?.title)) {
          existing.push(action?.payload);
        }
      }

      state.comparedList = existing;
    },
    removeComparedItem: (state, action: PayloadAction<compareItem>) => {
      let existing = Array.isArray(state.comparedList)
        ? state.comparedList
        : [];

      if (action?.payload) {
        existing = existing.filter(
          (item) => item?.title !== action?.payload?.title
        );
      }

      state.comparedList = existing;
    },
    setSelectedColumn: (state, action: PayloadAction<number>) => {
      state.selectedColumn = action?.payload;
    },
  },
});

export const Actions = slice.actions;
export default slice.reducer;
